export default __webpack_public_path__ + "static/vc_right-926c0826f3a8815350bf3a53bb6e08c2.png";